import { createContext, useContext, ReactNode } from 'react'
import { useVolumeControl } from '../hooks/useVolumeControl'

type VolumeContextType = {
  volume: number
  showIndicator: boolean
  adjustVolume: (delta: number) => void
  setVolume: (value: number) => void
  showVolumeIndicator: () => void
}

const VolumeContext = createContext<VolumeContextType | undefined>(undefined)

export function VolumeProvider({ children }: { children: ReactNode }) {
  const volumeControl = useVolumeControl()

  return (
    <VolumeContext.Provider value={volumeControl}>
      {children}
    </VolumeContext.Provider>
  )
}

export function useVolume() {
  const context = useContext(VolumeContext)
  if (!context) {
    throw new Error('useVolume must be used within VolumeProvider')
  }
  return context
}